import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'
import { NavLink } from 'react-router-dom'

const Footer = () => {
  return (
    <footer>
      <div className="waves">
      <div className="wave" id='wave1'></div>
      <div className="wave wave2"></div>
      <div className="wave wave3"></div>
      <div className="wave wave4"></div>
      </div>
{/*       <a href="#" className='footer_logo'>DEVIL</a> */}
      <a href="/" className='footer_logo'>DEVIL</a>
      <ul className='permalinks'>
        <li><NavLink to = "/">Home</NavLink></li>
        <li><NavLink to = "/about">About</NavLink></li>
        <li><NavLink to = "/experience">Experience</NavLink></li>
        <li><NavLink to = "/services">Services</NavLink></li>
        <li><NavLink to = "/faqs">Faq</NavLink></li>
        <li><NavLink to = "/contact">Contact</NavLink></li>
      </ul>

      <div className="footer_socials">
        <a href="https://facebook.com"><FaFacebookF /></a>
        <a href="https://instagram.com"><FiInstagram /></a>
        <a href="https://twitter.com"><IoLogoTwitter /></a>
      </div>

      <div className="footer_copyright">
        <small>
          &copy; DEVIL. All rights reserved.
        </small>
      </div>
    </footer>
  )
}

export default Footer
